import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      // eslint-disable-next-line camelcase
      visit_consentTemplate: {
         confirmAndPrint: 'Zatwierdź i drukuj',
         confirmingDocument: 'Zatwierdzanie zgody',
         consentTemplateFetchError: 'Nie udało się pobrać szablonu zgody.',
         leavingGuard: {
            successMessage: 'Wersja robocza zgody została zapisana.',
         },
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, 'visit_consentTemplate');
